import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("autorio_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        localStorage.removeItem("autorio_token");
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  },
);

export function assetUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  // Uploaded files are also served under /api so they route through an ingress
  // that only proxies /api/* to the backend.
  const path = url.startsWith("/uploads/") ? `/api${url}` : url;
  return `${ASSET_BASE}${path}`;
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "A apărut o eroare. Încearcă din nou.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  return String(d);
}

export default api;
